'use client';

interface WizardProgressProps {
  currentStep: number;
  totalSteps: number;
  locale: string;
}

export default function WizardProgressBar({
  currentStep,
  totalSteps,
  locale
}: WizardProgressProps) {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="wizard-progress-container">
      <div className="wizard-progress-bar-outer mt-3 lg:mt-0">
        <div
          className="wizard-progress-bar-inner"
          style={{ width: `${progress}%` }}
        />
      </div>
      {/* <div className="wizard-progress-text">
        {locale === 'it'
          ? `Passo ${currentStep} di ${totalSteps}`
          : `Step ${currentStep} of ${totalSteps}`}
      </div> */}
    </div>
  );
}